import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { Button, WhiteSpace, Toast, Modal } from 'antd-mobile'
import { createForm } from 'rc-form';
import { UrlSearch } from '../../../utils/utils'
import { GetCompanyList, UpgradeCompany } from '../../../api/usms'
import CompanyDetail from '../components/CompanyDetail';
import { AclKeys } from '../utils/permissions';
import Permission from '../components/Permission';

const alert = Modal.alert;
// 传递id，获取当前用户详情
function AddFreeAmount(props){

    const [companyInfo, setCompanyInfo] = useState({
        Upgrade: 0
    })
    const [loading, setLoading] = useState(true)
    const [confirmLoading, setConfirmLoading] = useState(false)

    const CompanyId = useMemo(() => {
        return UrlSearch("CompanyId")
    }, [])

    if(!CompanyId){
        props.history.push(`/usms/companylist`)
    }

    const getList = useCallback((data) => {
        setLoading(true);
        GetCompanyList(data).then(res => {
            const { Data, Message } = res;
            if (Data && Data.length) {
                const info = Data[0]
                setCompanyInfo(info);
            } else {
                Toast.fail(Message, 3);
            }
            setLoading(false);
        }).catch(e => {
            Toast.fail(e.message, 3);
            setLoading(false);
        });
    }, [])

    const onCancel = () => {
        props.history.push(`/usms/companylist`)
    }

    function successToast() {
        Toast.success('操作成功', 3);
    }

    function failToast(message) {
        Toast.fail(message, 3);
    }

    useEffect(() => {
        getList({CompanyIds: [Number(CompanyId)]})
    }, [getList])

    const UpgradeUser = (data) => {
        setConfirmLoading(true)
        UpgradeCompany(data).then(res => {
            const { RetCode, Message } = res;
            if(RetCode === 0){
                getList()
                successToast()
            }else{
                failToast(Message)
            }
            setConfirmLoading(false)
        }).catch(err => {
            failToast(err.message)
            setConfirmLoading(false)
        })
    }

    const showAlert = (value) => {
        alert('账户升级', `确认要升级${value.Email}账户吗???`, [
          { text: '取消', onPress: () => {}, style: 'default' },
          { text: '确认', onPress: () => {
            if(value){
                UpgradeUser({CompanyId: value.CompanyId})
            }else{
                failToast("用户未找到")
            }
          }},
        ]);
    };

    return <>
        {loading ? <div>
            loading...
        </div>:<div className="container">
            <h3 style={{paddingLeft: '10px', paddingBottom: '5px'}}>账户升级</h3>
            <Permission aclKey={AclKeys.SMSUpgrade}>
                <CompanyDetail detailInfo={companyInfo} />
                <Button disabled={companyInfo.Upgrade === 1} loading={confirmLoading} onClick={() => showAlert(companyInfo)} type="primary">升级</Button><WhiteSpace />
                <Button onClick={onCancel}>返回</Button><WhiteSpace />
            </Permission>
        </div>}
    </>
}
export default createForm()(withRouter(AddFreeAmount))